export default function DropIdentity(props) {
  return (
    <span>
      Drop Identity
    </span>
  )
}